import axios, { AxiosRequestConfig, Method } from "axios";
import { endpointUrl } from "src/services/connection";

type HttpMethod = "GET" | "POST" | "PUT" | "DELETE" | "PATCH";

const BASE_URL = endpointUrl;

const apiCall = async (
  endpoint: string,
  method: HttpMethod,
  data: any = null,
  headers: Record<string, string> = {}
): Promise<any> => {
  const normalizedEndpoint = endpoint.startsWith("/")
    ? endpoint
    : `/${endpoint}`;
  const url = `${BASE_URL}${normalizedEndpoint}`;
  const isFormData = data instanceof FormData;

  // API request configuration

  const config: AxiosRequestConfig = {
    url,
    method: method as Method,
    headers: {
      ...(!isFormData ? { "Content-Type": "application/json" } : {}),
      ...headers,
    },
    data,
  };

  try {
    const response = await axios(config);
    return response.data;
  } catch (error: any) {
    // API request failed
    const errorMsg =
      error.response?.data?.message || error.message || "Something went wrong";
    throw new Error(errorMsg);
  }
};

export default apiCall;
